/* ============================================================
   ANJUS — Enquiries page interactions (chips, photo, tabs)
   Forms POST to Shopify's native contact endpoint.
   ============================================================ */
(function () {
  'use strict';
  function singleSelect(group) {
    if (!group) return;
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      e.preventDefault();
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var hidden = group.parentElement.querySelector('input[type="hidden"]');
      if (hidden) hidden.value = btn.textContent.trim();
    });
  }
  singleSelect(document.getElementById('stones'));
  singleSelect(document.getElementById('appt-type'));

  var photo = document.getElementById('f-photo');
  if (photo) {
    photo.addEventListener('change', function () {
      var drop = document.getElementById('f-photo-drop');
      var name = document.getElementById('f-photo-name');
      if (photo.files && photo.files.length) { name.textContent = photo.files[0].name; drop.classList.add('has-file'); }
      else { name.textContent = ''; drop.classList.remove('has-file'); }
    });
  }

  var tabs = document.querySelectorAll('.etab');
  var enquiryFields = document.getElementById('enquiry-fields');
  var bookingFields = document.getElementById('booking-fields');
  var heading = document.getElementById('enquiry-heading');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var panel = tab.getAttribute('data-panel');
      tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.style.borderBottomColor = on ? '#B5601C' : 'transparent'; t.style.color = on ? '#2E1E10' : 'rgba(46,30,16,0.5)'; });
      if (!enquiryFields || !bookingFields) return;
      if (panel === 'booking') { enquiryFields.style.display = 'none'; bookingFields.style.display = ''; if (heading) heading.textContent = 'Book an Appointment'; }
      else { enquiryFields.style.display = ''; bookingFields.style.display = 'none'; if (heading) heading.textContent = 'Begin a Conversation'; }
    });
  });
})();
